import React, { useState } from "react";
import Time from "./Time";
import Marquee from "./Marquee";
import ProfitLoss from "./ProfitLoss";
import "../../../Utils/Css/Footer.css";

export default function Footer() {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleLogoutClick = () => setShowConfirm(true);
  const confirmLogout = () => {
    setShowConfirm(false);
    window.LogOut?.(); // Optional chaining for safety
  };
  const cancelLogout = () => setShowConfirm(false);

  return (
    <>
      <footer className="FooterContainer">
        {/* Left Section */}
        <div className="FooterLeft">
          <Time />
          <Marquee />
        </div>

        {/* Right Section */}
        <div className="FooterRight">
          <ProfitLoss />

          <button
            onClick={handleLogoutClick}
            className={`bg-[var(--sell)] text-[14px] relative flex items-center justify-center gap-1 px-2 py-0.3 text-[var(--white)] font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
          >
            LOGOUT
          </button>
        </div>
      </footer>

      {/* ✅ Logout Confirmation Modal */}
      {showConfirm && (
        <div className="logoutModalOverlay">
          <div className="logoutModal">
            <h3 className="logoutTitle">Confirm Logout</h3>
            <p className="logoutText">Are you sure you want to log out?</p>

            <div className="logoutModalButtons">
              <button className="confirmBtn" onClick={confirmLogout}>
                Yes, Logout
              </button>
              <button className="cancelBtn" onClick={cancelLogout}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
